// Task statuses
export const TASK_STATUSES = {
  new: 'Yangi',
  viewed: 'Tanishildi',
  in_progress: 'Bajarilmoqda',
  pending: 'Tekshiruvda',
  submitted: 'Yuborildi',
  completed: 'Bajarildi',
  completed_late: 'Kech bajarildi',
  approved: 'Qabul qilindi',
  rejected: 'Qaytarildi',
  not_completed: 'Bajarilmadi',
  archived: 'Arxivlangan',
};

// Task priorities
export const TASK_PRIORITIES = {
  low: 'Past',
  medium: 'O\'rta',
  high: 'Yuqori',
  urgent: 'Shoshilinch',
};

// Task types
export const TASK_TYPES = {
  regular: 'Oddiy topshiriq',
  centralized: 'Markazlashgan topshiriq',
  thematic: 'Mavzuli o\'rganish',
  discipline: 'Ijro intizomi',
};

// User roles
export const USER_ROLES = {
  admin: 'Vazirlik auditori (Admin)',
  otm_auditor: 'OTM auditori',
  rector: 'Rektor/Rahbariyat',
};

// Report types
export const REPORT_TYPES = {
  quarterly: 'Choraklik',
  yearly: 'Yillik',
  monthly: 'Oylik',
};

// Report statuses
export const REPORT_STATUSES = {
  draft: 'Qoralama',
  submitted: 'Yuborilgan',
  approved: 'Tasdiqlangan',
  rejected: 'Qaytarilgan',
};

// Document types
export const DOCUMENT_TYPES = {
  normative: 'Me\'yoriy hujjat',
  news: 'Yangilik',
  instruction: 'Yo\'riqnoma',
};

// Risk severities
export const RISK_SEVERITIES = {
  low: 'Past',
  medium: 'O\'rta',
  high: 'Yuqori',
  critical: 'Jiddiy',
};

// Risk statuses
export const RISK_STATUSES = {
  identified: 'Aniqlangan',
  assigned: 'Yuborilgan',
  in_progress: 'Tekshirilmoqda',
  resolved: 'Hal qilingan',
};

// Notification types
export const NOTIFICATION_TYPES = {
  task_created: 'Yangi topshiriq',
  task_deadline: 'Muddat yaqinlashdi',
  task_overdue: 'Muddat o\'tdi',
  task_submitted: 'Topshiriq yuborildi',
  task_approved: 'Topshiriq qabul qilindi',
  task_rejected: 'Topshiriq qaytarildi',
  message: 'Xabar',
  system: 'Tizim xabari',
};

// Workplan statuses
export const WORKPLAN_STATUSES = {
  draft: 'Qoralama',
  approved: 'Tasdiqlangan',
  in_progress: 'Bajarilmoqda',
  completed: 'Bajarildi',
};

// Workplan types
export const WORKPLAN_TYPES = {
  ministry: 'Vazirlik',
  otm: 'OTM',
};

// KPI Categories with max scores
export const KPI_CATEGORIES = {
  prevented_errors: { name: 'Oldi olingan xato-kamchiliklar', maxScore: 20 },
  optimized_expenses: { name: 'Ortiqcha va samarsiz xarajatlarni maqbullashtirish', maxScore: 20 },
  restored_to_budget: { name: 'Tiklangan xato-kamchiliklar', maxScore: 20 },
  remote_monitoring: { name: 'Masofaviy nazarat natijalari', maxScore: 15 },
  recommendations: { name: 'Taklif va tavsiyalar', maxScore: 10 },
  additional_tasks: { name: 'Qo\'shimcha topshiriqlar', maxScore: 5 },
  ministry_tasks: { name: 'Vazirlik topshiriqlari', maxScore: 5 },
  methodological_errors: { name: 'Uslubiy xatolar', maxScore: 5 },
};

// Regions of Uzbekistan
export const REGIONS = [
  { code: 'TK', name: 'Toshkent shahri' },
  { code: 'TO', name: 'Toshkent viloyati' },
  { code: 'AN', name: 'Andijon viloyati' },
  { code: 'BU', name: 'Buxoro viloyati' },
  { code: 'FA', name: 'Farg\'ona viloyati' },
  { code: 'JI', name: 'Jizzax viloyati' },
  { code: 'XO', name: 'Xorazm viloyati' },
  { code: 'NG', name: 'Namangan viloyati' },
  { code: 'NV', name: 'Navoiy viloyati' },
  { code: 'QA', name: 'Qashqadaryo viloyati' },
  { code: 'QQ', name: 'Qoraqalpog\'iston Respublikasi' },
  { code: 'SA', name: 'Samarqand viloyati' },
  { code: 'SI', name: 'Sirdaryo viloyati' },
  { code: 'SU', name: 'Surxondaryo viloyati' },
];

// Quarters
export const QUARTERS = [
  { value: 1, label: '1-chorak (Yanvar-Mart)' },
  { value: 2, label: '2-chorak (Aprel-Iyun)' },
  { value: 3, label: '3-chorak (Iyul-Sentyabr)' },
  { value: 4, label: '4-chorak (Oktyabr-Dekabr)' },
];

// Current year and available years
export const CURRENT_YEAR = new Date().getFullYear();
export const YEARS_ = Array.from({ length: 4 }, (_, i) => CURRENT_YEAR - i);
export const YEARS = Array.from({ length: 7 }, (_, i) => CURRENT_YEAR - 3 + i);

// Pagination
export const PAGE_SIZES = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;

// File upload limits
export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
export const ALLOWED_FILE_TYPES = ['pdf', 'docx', 'xlsx'];
export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
